import React from "react";

function Projects() {
  return (
    <div id="projects" className="pt-20">
      <h1 className="px-10 mt-20 text-3xl font-bold text-center text-blue-500">
        My Projects
      </h1>

      <div className="grid grid-cols-1 gap-8 p-4 my-10 md:grid-cols-2 lg:grid-cols-3 md:px-20 lg:px-60">

        {/* Project 1 */}
        <div className="p-6 bg-gray-800 h-64 rounded-lg shadow-[0_0px_5px_rgba(255,255,255,0.3)] hover:shadow-[0_10px_20px_rgba(255,255,255,0.4)] transition-shadow duration-300 flex flex-col justify-between">
          <div>
            <h3 className="text-3xl font-semibold text-center text-blue-500">
              Packpal
            </h3>
            <p className="mt-3 text-lg text-center text-gray-300">
              Smart packing assistant that helps travellers create packing lists.
            </p>
          </div>
          <a
            href="https://github.com/Kush-012/Chatbot-packing-assistant"
            target="_blank"
            rel="noopener noreferrer"
            className="text-center text-blue-400 hover:underline"
          >
            View on GitHub →
          </a>
        </div>

        {/* Project 2 */}
        <div className="p-6 bg-gray-800 h-64 rounded-lg shadow-[0_0px_5px_rgba(255,255,255,0.3)] hover:shadow-[0_10px_20px_rgba(255,255,255,0.4)] transition-shadow duration-300 flex flex-col justify-between">
          <div>
            <h3 className="text-3xl font-semibold text-center text-blue-500">
              Transportation and Logistics
            </h3>
            <p className="mt-3 text-lg text-center text-gray-300">
              Built to connect shippers and drivers on a single intelligent network.
            </p>
          </div>
          <a
            href="https://github.com/Kush-012/Transportation-and-Logistics"
            target="_blank"
            rel="noopener noreferrer"
            className="text-center text-blue-400 hover:underline"
          >
            View on GitHub →
          </a>
        </div>

        {/* Project 3 */}
        <div className="p-6 bg-gray-800 h-64 rounded-lg shadow-[0_0px_5px_rgba(255,255,255,0.3)] hover:shadow-[0_10px_20px_rgba(255,255,255,0.4)] transition-shadow duration-300 flex flex-col justify-between">
          <div>
            <h3 className="text-3xl font-semibold text-center text-blue-500">
              Unibazzar
            </h3>
            <p className="mt-3 text-lg text-center text-gray-300">
              
              It is a hyperlocal campus marketplace where students can buy, sell and recover items
            </p>
          </div> 
          <a
            href="https://github.com/Kush-012/Unibazzar"
            target="_blank"
            rel="noopener noreferrer"
            className="text-center text-blue-400 hover:underline"
          >
            View on GitHub →
          </a>
        </div>

      </div>
    </div>
  );
}

export default Projects;
